export const formatNumberWithCommas = (
  n: number | null | undefined
): string => {
  let val = Math.round(Number(n) * 100) / 100;
  let parts = val.toString().split('.');
  let num =
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
    (parts[1] ? '.' + parts[1] : '');
  return num;
};

export const formatNumberDigits = (
  num: number | null | undefined,
  digits: number = 2
): string => (typeof num === 'number' ? num.toFixed(digits) : '');

export const abbreviateNumber = (number: number): string => {
  const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
  // what tier? (determines SI symbol)
  const tier = (Math.log10(Math.abs(number)) / 3) | 0;

  // if zero, we don't need a suffix
  if (tier == 0) return `${number}`;

  // get suffix and determine scale
  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);

  // scale the number
  const scaled = number / scale;

  // format number and add suffix
  return `${scaled.toFixed(1) + suffix}`.replace('.0', '').toUpperCase();
};
